import { Button } from "@/components/shared/Button/Button";
import { Input } from "@/components/shared/Input/Input";
import Title from "@/components/shared/Title/Title";
import LayoutOutside from "@/layout/LayoutOutside";
import Password from "@/assets/icons/Password";
import { useResetPassword } from "./hooks/useResetPassword";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export function ResetPassword() {
  const { t } = useTranslation("common");
  const {
    onSubmit,
    handleSubmit,
    register,
    errors,
    isSubmitting,
    isError,
    isSuccess,
    email,
  } = useResetPassword();

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === '@passwordResetSuccess' && e.newValue === 'true') {
        if (window.opener) {
          window.opener.close();
        }

        localStorage.setItem('@closeTabs', Date.now().toString());
        localStorage.removeItem('@passwordResetSuccess');
      }
    };

    const handleTabClose = (e: StorageEvent) => {
      if (e.key === '@closeTabs') {
        window.close();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('storage', handleTabClose);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('storage', handleTabClose);
    };
  }, []);

  return (
    <LayoutOutside
      isError={isError}
      isSuccess={isSuccess}
      isLoading={isSubmitting}
      route="/login"
      text={t("login")}
      classNameMainContainer="flex items-center justify-center h-[calc(100vh-80px)]"
    >
      <form
        className="space-y-8 rounded-lg max-w-[416px] w-full"
        onSubmit={handleSubmit(onSubmit)}
      >
        <header className="flex flex-col gap-4 mb-6">
          <Password />
          <Title text={t("resetPassword")} />
          {email && (
            <p className="text-gray-400 text-sm">
              {t("email")}: <span className="text-white">{email}</span>
            </p>
          )}
        </header>

        <div className="space-y-6">
          <div className="space-y-1">
            <Input
              type="password"
              label={t("password")}
              placeholder={t("password_placeholder")}
              helperText={errors?.password?.message as string}
              disabled={isSubmitting}
              {...register("password")}
            />
            <p className="text-xs text-gray-500">{t("passwordRule")}</p>
          </div>

          <Input
            type="password"
            label={t("confirmPassword")}
            placeholder={t("confirma_password_placeholder")}
            helperText={errors?.password_confirmation?.message as string}
            disabled={isSubmitting}
            {...register("password_confirmation")}
          />
        </div>

        <Button
          variant="primary"
          className="w-full bg-newLime hover:bg-lime-400 text-black py-2 rounded-md"
          type="submit"
          disabled={isSubmitting}
        >
          {isSubmitting ? t("saving") : t("save_new_password")}
        </Button>
      </form>
    </LayoutOutside>
  );
}
